// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4cdf2c80","455":"71f2ed2e"}[chunkId] + ".chunk.js";
};